import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useCallback } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableRow, Typography, useTheme, } from '@mui/material';
import { EmptyRow } from '../empty-row';
import { DragDropContext, Draggable, Droppable, } from 'react-beautiful-dnd';
import { TableHeader } from '../table-header';
import { DraggableRow } from './draggable-row';
import { getItemStyle, getListStyle, reorder, } from 'console/device-settings/z3k/components/utils/DragDropList';
export function MaterialTableWithDnd(props) {
    const { containerProps, tableProps, tableHeaderProps, rowComponentFunction, table_data, onChangeData, emptyRowLabel, } = props;
    const { withAddButton, withRemoveButton, columns_name } = tableHeaderProps;
    const theme = useTheme();
    const onDragEnd = useCallback((result) => {
        if (!result.destination) {
            return;
        }
        onChangeData(reorder(table_data, result.source.index, result.destination.index));
    }, [onChangeData, table_data]);
    function onClickDelete(row_index) {
        const new_data = table_data.slice();
        new_data.splice(row_index, 1);
        onChangeData(new_data);
    }
    function onChangeRow(index) {
        return (data) => {
            const new_table_data = table_data.slice();
            onChangeData([
                ...new_table_data.slice(0, index),
                data,
                ...new_table_data.slice(index + 1),
            ]);
        };
    }
    const columns_number = withRemoveButton || withAddButton
        ? columns_name.length + 1
        : columns_name.length;
    function onCreateRow(item, index) {
        return (_jsx(Draggable, { draggableId: index.toString(), index: index, isDragDisabled: false, children: (provided, snapshot) => (_jsx(TableRow, { ref: provided.innerRef, ...provided.draggableProps, ...provided.dragHandleProps, style: getItemStyle(snapshot, provided.draggableProps.style, theme.palette.mode === 'dark'), children: _jsx(DraggableRow, { row_index: index, withRemoveButton: withRemoveButton, withAddButton: withAddButton, onClickDelete: onClickDelete, children: rowComponentFunction != null
                        ? rowComponentFunction({
                            values: item,
                            onChangeRow: onChangeRow(index),
                        })
                        : simpleRow(item) }) })) }, index));
    }
    return (_jsx(TableContainer, { ...containerProps, children: _jsxs(Table, { stickyHeader: true, ...tableProps, children: [_jsx(TableHeader, { ...tableHeaderProps }), _jsx(DragDropContext, { onDragEnd: onDragEnd, children: _jsx(Droppable, { droppableId: "droppable", direction: "vertical", children: (provided, snapshot) => (_jsxs(TableBody, { ref: provided.innerRef, style: getListStyle(snapshot.isDraggingOver, theme.palette.mode === 'dark'), ...provided.droppableProps, children: [table_data.length !== 0 ? (table_data.map(onCreateRow)) : (_jsx(EmptyRow, { title: emptyRowLabel != null
                                        ? emptyRowLabel
                                        : 'Таблица пуста', colSpan: columns_number })), provided.placeholder] })) }) })] }) }));
}
function simpleRow(item) {
    return Object.entries(item).map(([key, value]) => (_jsx(TableCell, { children: _jsx(Typography, { children: value }) }, key)));
}
